<template>
    <div>
        <headful
            title="Caseen - Logging In"
        />
        <h2>Logging in:</h2>
        <br><br>
        <md-progress-spinner 
            v-if="serverError == undefined"
            :md-diameter="60" 
            :md-stroke="10" 
            md-mode="indeterminate">
        </md-progress-spinner>
        <md-empty-state
            v-if="serverError != undefined"
            md-icon="error"
            :md-label="'Server Error: ' + serverError" 
            md-description="Failed to login, redirecting...">
        </md-empty-state>
    </div>
</template>

<script>
    import APIRequests from "./APIRequests.js"
    import * as Sentry from '@sentry/browser'

    export default {
        props: {
            provider: {
                type: String
            },  
        },
        data: function(){
            return {
                serverError: undefined
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                var urlParams = this.$route.query
                var url
                if(this.provider == "cas"){
                    if(!urlParams.ticket){
                        window.location = this.$store.state.api_url + "/api/auth/" + this.provider
                        return
                    }
                    url = this.$store.state.api_url + "/api/auth/" + this.provider + "/callback"
                    url += "?ticket=" + encodeURIComponent(urlParams.ticket)
                    if(urlParams.source){
                        url += "&source=" + urlParams.source
                    }
                }
                else {
                    if(!(urlParams.state && urlParams.code)){
                        window.location = this.$store.state.api_url + "/api/auth/" + this.provider
                        return
                    }   
                    url = this.$store.state.api_url + "/api/auth/" + this.provider + "/callback"
                    url += "?state=" + encodeURIComponent(urlParams.state)
                    url += "&code=" + encodeURIComponent(urlParams.code)
                }
                APIRequests.getJSONData(url).then((data) => {
                    this.$store.commit("setJWTToken", data.token)
                    //Update user in vue
                    Sentry.configureScope((scope) => {
                        scope.setUser({
                            id: this.$store.state.jwtClaims.email,
                            username: this.$store.state.jwtClaims.pid,
                            email: this.$store.state.jwtClaims.email,
                        });
                    });
                    //Redirect after login
                    if(urlParams.source){
                        var authSource = urlParams.source.replace(/~~/g, "?").replace(/~/g, "&")
                        window.location = authSource
                    }
                    else {
                        window.location = "/"
                    }
                }).catch(([xhrStatus]) => {
                    this.serverError = xhrStatus
                    setTimeout(() => {
                        window.location = this.$store.state.api_url + "/api/auth/" + this.provider
                    }, 1500)
                })
            })
        }
    }
</script>
